import {Rest} from "../../common/api/rest/Rest";
import {VendorList} from "../model/vendor/VendorList";

export class RestVendor extends Rest {
    getVendorLists(): Promise<VendorList[]> {
        return this._client.get("customer/vendor", VendorList) as Promise<VendorList[]>;
    }
}
